import React from "react";
import styled from "styled-components";

const PerformanceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 240px;
  padding-bottom: 8px;
  cursor: pointer;

  ${p =>
    p.isActive &&
    `
    border-bottom: 4px solid hsla(218, 43%, 29%, 1);
  `}
`;

const PerformanceName = styled.div`
  font-family: "Mukta Vaani", sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: hsla(213, 100%, 12%, 0.94);
`;

const PerformanceValue = styled.div`
  font-family: "Mukta Vaani";
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: hsla(213, 100%, 12%, 0.6);
`;

const Performance = ({ handleShowTab, id, name, value, isActive }) => {
  return (
    <PerformanceBlock onClick={() => handleShowTab(id)} isActive={isActive}>
      <PerformanceName>{name}</PerformanceName>
      <PerformanceValue>{value}</PerformanceValue>
    </PerformanceBlock>
  );
};

export default Performance;



// WEBPACK FOOTER //
// ./src/components/peer-review/performance.js